import React, { createContext, useContext, useState, useCallback } from "react";
import { PublicClientApplication, IPublicClientApplication, Configuration } from "@azure/msal-browser";


interface MsalDynamicContextType {
  msalInstance: IPublicClientApplication | null;
  setMsalInstance: (instance: IPublicClientApplication | null) => void;
  createMsalInstance: (config: Configuration) => IPublicClientApplication;
}

const MsalDynamicContext = createContext<MsalDynamicContextType | undefined>(undefined);

export const useMsalDynamic = () => {
  const ctx = useContext(MsalDynamicContext);
  if (!ctx) throw new Error("useMsalDynamic must be used within MsalDynamicProvider");
  return ctx;
};

export const MsalDynamicProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [msalInstance, setMsalInstance] = useState<IPublicClientApplication | null>(null);

  const createMsalInstance = useCallback((config: Configuration) => {
    return new PublicClientApplication(config);
  }, []);

  const contextValue = React.useMemo(
    () => ({ msalInstance, setMsalInstance, createMsalInstance }),
    [msalInstance, setMsalInstance, createMsalInstance]
  );

  return (
    <MsalDynamicContext.Provider value={contextValue}>
      {children}
    </MsalDynamicContext.Provider>
  );
};
